/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guest_Picker_Infants_HintInputs */

const en_guest_picker_infants_hint = /** @type {(inputs: Guest_Picker_Infants_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Under 2`)
};

/**
* | output |
* | --- |
* | "Under 2" |
*
* @param {Guest_Picker_Infants_HintInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const guest_picker_infants_hint = /** @type {((inputs?: Guest_Picker_Infants_HintInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guest_Picker_Infants_HintInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_guest_picker_infants_hint(inputs)
});